module.exports = __webpack_public_path__ + "static/media/bag.95da43dd.svg";